import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, CheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { IMAGES } from './constants';
const badges = ['Acceso inmediato', 'Descarga digital', 'Garantía de 7 días'];
export function Hero() {
  return <section className="relative w-full overflow-hidden bg-cream" data-id="element-85" data-mp="4lyxkshw2qgt">
      <div className="pointer-events-none absolute -right-24 -top-24 h-96 w-96 rounded-full bg-rose-soft/50 blur-3xl" data-id="element-86" data-mp="4jm5hmif2zq1" />
      <div className="pointer-events-none absolute -bottom-32 -left-24 h-96 w-96 rounded-full bg-gold-soft/30 blur-3xl" data-id="element-87" data-mp="xae7j0m5yila" />

      <div className="relative mx-auto grid max-w-6xl grid-cols-1 items-center gap-10 px-5 py-14 sm:px-6 lg:grid-cols-2 lg:gap-14 lg:py-20" data-id="element-88" data-mp="sarsqmqosuad">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} data-id="element-89" data-mp="nbygexn4z9bs">
          <span className="inline-flex items-center gap-2 rounded-full border border-coral/30 bg-white/60 px-4 py-1.5 text-xs font-semibold uppercase tracking-wider text-coral-dark" data-id="element-90" data-mp="381e1dbzoc3ti">
            Ebook + 3 bonos · Contenido UGC
          </span>

          <h1 className="mt-5 font-display text-4xl font-semibold leading-[1.08] text-plum sm:text-5xl lg:text-[3.4rem]" data-id="element-91" data-mp="3o59d9ms2zcg4">
            Pasá de cero a tu portfolio, tus servicios y{' '}
            <span className="text-coral" data-id="element-92" data-mp="3e7l7m1sxskj6">+80 marcas contactadas en 7 días</span>
          </h1>

          <p className="mt-5 max-w-xl text-base leading-relaxed text-ink/80 sm:text-lg" data-id="element-93" data-mp="30gq47517ivmz">
            Construí tu camino hacia tus primeros{' '}
            <span className="font-semibold text-plum" data-id="element-94" data-mp="2qk3i6cx59yjd">USD 1.000</span> con contenido UGC,
            incluso si todavía no tenés experiencia, clientes, testimonios ni miles de
            seguidores.
          </p>

          <div className="mt-8 flex flex-col items-start gap-4 sm:flex-row sm:items-center" data-id="element-95" data-mp="2hix03zeukfo0">
            <CTAButton data-id="element-96" data-mp="2lla9cxssyvpj">Quiero empezar hoy</CTAButton>
            <div className="flex items-center gap-2" data-id="element-97" data-mp="2lmv0edfwrwin">
              <div className="flex" data-id="element-98" data-mp="s2bc6ahwz5ay">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-gold text-gold" data-id="element-99" data-mp="nat6xa8uyik6" data-mpi={i} />)}
              </div>
              <span className="text-sm text-ink/70" data-id="element-100" data-mp="id9vei3jojvx">
                <span className="font-semibold text-plum" data-id="element-101" data-mp="i9vp4yrrfqj7">+500</span> creadoras
              </span>
            </div>
          </div>

          <ul className="mt-7 flex flex-wrap gap-x-5 gap-y-2" data-id="element-102" data-mp="1b15olctwntny">
            {badges.map(b => <li key={b} className="flex items-center gap-1.5 text-sm text-ink/75" data-id="element-103" data-mp="161jbd3e2udf5">
                <CheckIcon className="h-4 w-4 text-coral" data-id="element-104" data-mp="112g5xhu6q56n" />
                {b}
              </li>)}
          </ul>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.7,
        ease: 'easeOut',
        delay: 0.1
      }} className="relative mx-auto w-full max-w-lg" data-id="element-105" data-mp="x0l3ub4fjnrt">
          <div className="absolute -inset-3 rounded-[2rem] bg-gradient-to-br from-rose-soft to-gold-soft/40" data-id="element-106" data-mp="1x9kwertfdeju" />
          <img src={IMAGES.ebook} alt="Portada del ebook Tus primeros USD 1.000 con contenido UGC" className="relative aspect-[4/5] w-full rounded-[1.8rem] object-cover shadow-soft" data-id="element-107" data-mp="21aejjiz1mpbo" />
          <div className="absolute -bottom-5 left-4 rounded-2xl bg-white/95 px-4 py-3 shadow-card backdrop-blur sm:left-6" data-id="element-108" data-mp="2b1hgq9ouqk5o">
            <p className="text-xs font-medium text-ink/60" data-id="element-109" data-mp="2g1wtp0581pn4">Tu guía para empezar</p>
            <p className="font-display text-xl font-semibold text-coral" data-id="element-110" data-mp="2kxc9vyqpbxmp">Ebook + 3 bonos</p>
          </div>
        </motion.div>
      </div>
    </section>;
}